import { useWhenProviderReady } from '@openfeature/react-sdk';
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  useFeatureFlag,
} from '../../../../../../lib/featureFlags';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/reports'
)({
  staticData: { ddViewName: 'experiments-reports-tab' },
  component: ReportsGate,
});

function ReportsGate() {
  // Gate in the component (not beforeLoad) so it reacts to the OpenFeature
  // provider becoming ready. On a cold load / refresh the provider isn't ready
  // yet, so a flag read returns its default (false) — gating in beforeLoad would
  // 404 a legitimately-enabled tab. useWhenProviderReady lets us wait for the
  // real provider before deciding.
  const flagsReady = useWhenProviderReady();
  const reportsTabEnabled = useFeatureFlag(FEATURE_FLAGS.reportsTab);

  if (!flagsReady) {
    return null;
  }

  // With the flag off the Reports tab doesn't exist for this user.
  if (!reportsTabEnabled) {
    throw notFound();
  }

  return <Outlet />;
}
